import { EntityList } from '@/common/entityFramework/entityList/EntityList';
import { ExprUtils } from '@/common/utils/ExprUtils';
import { augInctvFieldDefs } from '@/sc/inctvFieldDefs';
import { useCallback } from 'react';

export const InctvInvClaimPymtList = ({ inctvInvId, pymtId }) => {
  const augRowsReq = useCallback(
    (rowsReq) => {
      if (inctvInvId) {
        rowsReq.expr = ExprUtils.and(rowsReq.expr, ExprUtils.whereParams('inctvInvId', inctvInvId));
      }

      if (pymtId) {
        rowsReq.expr = ExprUtils.and(rowsReq.expr, ExprUtils.whereParams('pymtId', pymtId));
      }
    },
    [inctvInvId, pymtId]
  );

  return <EntityList entity="INCTV_INV_CLAIM_PYMT" augRowsReq={augRowsReq} augFieldDefs={augInctvFieldDefs} />;
};
